import { getAutomatedMarketingCampaignStatusFilterOptions } from 'containers/campaigns/marketing/utils/automatedMarketingCampaignStatus';
import { buildMarketingCampaignListQueryParams } from 'containers/campaigns/marketing/utils/marketingCampaignListQueryParams';

import CampaignsMarketingManager from './CampaignsMarketingManager';

export default class AutomatedCampaignsMarketingManager extends CampaignsMarketingManager {
    getNewApiListParams = (filters) => ({
        ...buildMarketingCampaignListQueryParams(filters),
        type: 'automated',
    });

    getNewApiCountParams = (filters) => ({
        ...buildMarketingCampaignListQueryParams(filters),
        type: 'automated',
    });

    getStatusFilterOptions = getAutomatedMarketingCampaignStatusFilterOptions;
}
